module.exports = __webpack_public_path__ + "static/media/Caterpie_gaussian2.4b13a924.png";